export const ADMINISTRAR_CATALOGO = 'AdministrarCatalogo';
export const CREAR_CATALOGO = 'CrearCatalogo';
export const EDITAR_CATALOGO = 'EditarCatalogo';
export const ELIMINAR_CATALOGO = 'EliminarCatalogo';
export const ADMINISTRAR_USUARIO = 'AdministrarUsuario';
export const CREAR_USUARIO = 'CrearUsuario';
export const EDITAR_USUARIO = 'EditarUsuario';
export const ELIMINAR_USUARIO = 'EliminarUsuario';
export const EDITAR_AYUDA_CONTEXTUAL = 'EditarAyudaContextual';
export const ADMINISTRAR_ROL = 'AdministrarRol';
export const CREAR_ROL = 'CrearRol';
export const EDITAR_ROL = 'EditarRol';
export const ELIMINAR_ROL = 'EliminarRol';
export const CONFIRMAR_RESERVA = 'ConfirmarReserva';
export const ADMINISTRAR_EMPRESA = 'AdministrarEmpresa';
export const CREAR_EMPRESA = 'CrearEmpresa';
export const EDITAR_EMPRESA = 'EditarEmpresa';
export const ELIMINAR_EMPRESA = 'EliminarEmpresa';
export const ADMINISTRAR_MIEMPRESA = 'AdministrarMiEmpresa';
export const EDITAR_MIEMPRESA = 'EditarMiEmpresa';
export const ADMINISTRAR_DISCLAIMER = 'AdministrarDisclaimer';
export const ADMINISTRAR_PERSONAS = 'AdministrarPersona';
